module.exports = __webpack_public_path__ + "static/media/adaStand.ba53c36d.jpg";